import { render, staticRenderFns } from "./FaceConfig.vue?vue&type=template&id=09e9d25d"
import script from "./FaceConfig.vue?vue&type=script&lang=ts"
export * from "./FaceConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports